export function parseRoles(raw: string | null | undefined): string[] {
  if (!raw) return [];

  const trimmed = raw.trim();
  if (!trimmed) return [];

  try {
    const parsed = JSON.parse(trimmed);
    if (Array.isArray(parsed)) {
      return parsed
        .map((role) => (typeof role === 'string' ? role.trim().toLowerCase() : ''))
        .filter((role) => role.length > 0);
    }
  } catch {
    // Not JSON, fallback to string parsing
  }

  return trimmed
    .split(',')
    .map((role) => role.trim().toLowerCase())
    .filter((role) => role.length > 0);
}
